// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"056b1b31","568":"29f5d028","668":"f07847e3","787":"973cd13b","826":"57bfd365","864":"99625c13"}[chunkId] + ".chunk.js";
};